import { ICommand } from 'core-ts-types';
import { Resource } from './../../builders/resource_builder';

export class ResourceCardController {
  constructor(private deleteResourceCommand: ICommand) {}

  onDelete(resource: Resource) {
    this.deleteResourceCommand(resource);
  }
}

angular
  .module('capability-ng-resources')
  .controller('ngResourceCardController', ResourceCardController)
  .component('resourceCard', {
    templateUrl: 'lib/resources/components/resource_card/resource_card.html',
    controller: 'ngResourceCardController',
    controllerAs: '$ctrl',
    bindings: {
      resource: '<'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/resources/components/resource_card/resource_card.ts